import { gql } from '@apollo/client';
import { mutation } from 'services/graphql';

export const updateSurfaceNodeLinkSettingsMutation = gql`
  mutation updateSurfaceNodeLinkSettings(
    $input: UpdateSurfaceNodeLinkSettingsInput!
  ) {
    updateSurfaceNodeLinkSettings(input: $input) {
      data {
        color
        startShape
        endShape
        linkType
        linkName
      }
      success
      error
    }
  }
`;

export default mutation(updateSurfaceNodeLinkSettingsMutation);
